import { motion } from "framer-motion";
import { User, Phone } from "lucide-react";

const fadeUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
};

const teamMembers = [
  {
    name: "Naranbhai Mandabhai Solanki",
    role: "Nursery Manager",
    phone: "98986 73259",
  },
  {
    name: "Babubhai Mandabhai Solanki",
    role: "Nursery Manager",
    phone: "96620 59853",
  },
  {
    name: "Solanki Abhishekbhai Naranbhai",
    role: "Nursery Manager",
    phone: "98259 11774",
  },
];

export default function TeamSection() {
  return (
    <section
      className="py-20 md:py-32 bg-[#F9F8F4]"
      data-testid="team-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <motion.div {...fadeUp} className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-sm font-medium tracking-widest uppercase text-[#E07A5F] mb-4 block">
            Our Team
          </span>
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-semibold text-[#1A1C18] mb-6 tracking-tight"
            style={{ fontFamily: "'Fraunces', serif" }}
          >
            Proprietor & Management
          </h2>
          <p className="text-[#4A4F45] text-lg leading-relaxed">
            Meet the dedicated team behind Kishan Coconut Nursery.
          </p>
        </motion.div>

        {/* Proprietor */}
        <motion.div
          {...fadeUp}
          transition={{ ...fadeUp.transition, delay: 0.1 }}
          className="bg-[#2F5233] p-8 md:p-12 rounded-3xl mb-8 text-center"
        >
          <div className="w-24 h-24 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <User className="w-12 h-12 text-white" />
          </div>
          <p className="text-[#81B29A] text-sm font-medium tracking-widest uppercase mb-2">
            Proprietor
          </p>
          <h3
            className="text-3xl md:text-4xl font-bold text-white mb-4"
            style={{ fontFamily: "'Fraunces', serif" }}
          >
            Solanki Mandabhai Hamirbhai
          </h3>
          <p className="text-white/70 max-w-xl mx-auto">
            Leading Kishan Coconut Nursery with a vision to provide the best
            quality coconut seedlings to farmers across the region.
          </p>
        </motion.div>

        {/* Team Members */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {teamMembers.map((member, index) => (
            <motion.div
              key={member.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.8,
                ease: [0.22, 1, 0.36, 1],
                delay: 0.2 + index * 0.1,
              }}
              className="bg-white p-8 rounded-3xl border border-[#E5E2D9] text-center feature-card"
            >
              <div className="w-20 h-20 bg-[#F0EFE9] rounded-full flex items-center justify-center mx-auto mb-6">
                <User className="w-10 h-10 text-[#2F5233]" />
              </div>
              <h4
                className="text-xl font-semibold text-[#1A1C18] mb-2"
                style={{ fontFamily: "'Fraunces', serif" }}
              >
                {member.name}
              </h4>
              <p className="text-[#8C9187] text-sm mb-4">{member.role}</p>
              <a
                href={`tel:${member.phone.replace(/\s/g, "")}`}
                className="inline-flex items-center gap-2 text-[#2F5233] hover:text-[#1E3621] font-medium transition-colors"
                data-testid={`team-phone-${index}`}
              >
                <Phone className="w-4 h-4" />
                {member.phone}
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
